import { useTranslation } from 'react-i18next';

import { RequestFinalScreen } from 'components';

const CreditCardRequestSubmittedPage = () => {
  const { t } = useTranslation();

  return (
    <RequestFinalScreen
      title={t('card.request.submitted.title')}
      description={t('card.request.submitted.description')}
    />
  )
}

export default CreditCardRequestSubmittedPage;